angular.module("appVersion", [])
.constant("version", "4.57.2026062-6.2");
